module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// ./~/readable-stream/transform.js
// module id = 443
// module chunks = 1 5 6 7 9 10 11 13 15 16 22 23 25 29 30 59